import styled from 'styled-components';

export const BaseInfoText = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 16px;
  font-weight: 400;
`;

export const SkippedInfoText = styled(BaseInfoText)`
  color: ${({ theme }) => theme.palette.error.main};
`;

export const StyledModalActions = styled.div<{ $justify: string }>`
  display: flex;
  justify-content: ${({ $justify }) => $justify};
  margin-top: 30px;
`;
